export default __webpack_public_path__ + "static/media/25.3659c3e0.png";